<template>
    <div class="content">
        <div class="top-box">
            <div class="btn btn-home" @click="toHome">数据概览</div>
            <div class="btn-active btn-device">设备管理</div>
            <div class="btn btn-patient" @click="toUser">患者管理</div>
            <div class="btn btn-data" @click="toData">手表数据</div>
            <div class="btn-admin"></div>
            <img class="btn-icon" src="@/assets/home/04icon.png">
            <div class="user-name" @click="toAdmin">{{ loginName }}</div>
            <div class="time-box">{{ time }}</div>
        </div>
        <div class="main">
            <el-form :inline="true" label-position="top" size="mini">
                <el-form-item label="MAC">
                    <el-input v-model="mac" placeholder="请输入MAC"></el-input>
                </el-form-item>
                <el-form-item label="SN">
                    <el-input v-model="sn" placeholder="请输入SN"></el-input>
                </el-form-item>
                <el-form-item label="设备型号">
                    <el-cascader :options="watchModel" :props="{ expandTrigger: 'hover', emitPath: false }"
                                 v-model="watchType" placeholder="请选择设备型号" :show-all-levels="false"
                                 clearable></el-cascader>
                </el-form-item>
                <el-form-item label="设备状态">
                    <el-select v-model="isBind" placeholder="请选择">
                        <el-option
                            label="全部"
                            value="">
                        </el-option>
                        <el-option
                            label="已绑定"
                            value="1">
                        </el-option>
                        <el-option
                            label="未绑定"
                            value="0">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="患者">
                    <el-input v-model="userName" placeholder="请输入患者名称"></el-input>
                </el-form-item>
                <el-form-item label="绑定时间">
                    <el-date-picker
                        v-model="bindTime"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div class="btn-box">
                <div>
                    <el-button type="primary" @click="addVisible = true" size="mini" icon="el-icon-plus">新增设备
                    </el-button>
                    <el-button type="primary" @click="importTag = true" size="mini" icon="el-icon-plus" plain>批量增加
                    </el-button>
                    <el-button type="danger" @click="openDeleteDevice(1)" size="mini" icon="el-icon-close">删除设备</el-button>
                </div>
                <div>
                    <el-button type="info" @click="reset" size="mini">重置</el-button>
                    <el-button type="primary" @click="search" size="mini">查询</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                stripe
                border
                style="width: 100%"
                @selection-change="tableSelectionChange">
                <el-table-column type="selection"
                                 width="40">
                </el-table-column>
                <el-table-column
                    prop="id"
                    label="序号"
                >
                </el-table-column>
                <el-table-column
                    prop="watchType"
                    label="手表型号"
                >
                </el-table-column>
                <el-table-column
                    prop="sn"
                    label="SN"
                >
                </el-table-column>
                <el-table-column
                    prop="bleMac"
                    label="MAC"
                >
                </el-table-column>
                <el-table-column
                    prop="watchVersion"
                    label="固件版本"
                >
                </el-table-column>

                <el-table-column label="设备状态">
                    <template slot-scope="scope">
                        {{ scope.row.isBind === 1 ? '已绑定' : '未绑定' }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="绑定时间"
                >
                </el-table-column>
                <el-table-column
                    prop="userName"
                    label="患者"
                >
                </el-table-column>
                <el-table-column
                    prop="versionDec"
                    label="操作"
                    width="150">
                    <template slot-scope="scope">
                        <div>
                            <div class="table-btn table-btn0" @click="openEditDevice(scope.row)">编辑</div>
                            <div class="table-btn table-btn1" @click="deleteWatchBind(scope.row)" v-if="scope.row.isBind">解绑</div>
                            <div class="table-btn table-btn2" @click="openDeleteDevice(0, scope.row)">删除</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top: 15px">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :page-sizes="[20, 30, 40, 50]"
                    :page-size="20"
                    layout="prev, pager, next, sizes, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
            title="编辑设备"
            :visible.sync="addVisible"
            width="700px"
            :fullscreen="false"
            :close-on-click-modal="false"
        >
            <el-form size="mini">
                <el-form-item label="设备型号" label-width="100px">
                    <el-cascader :options="watchModel" :props="{ expandTrigger: 'hover', emitPath: false }"
                                 v-model="device.watchType" placeholder="请选择设备型号" :show-all-levels="false"
                                 clearable></el-cascader>
                </el-form-item>
                <el-form-item label="MAC" label-width="100px">
                    <el-input
                        type="text"
                        placeholder="请输入"
                        v-model="device.bleMac">
                    </el-input>
                </el-form-item>
                <el-form-item label="SN" label-width="100px">
                    <el-input
                        type="text"
                        placeholder="请输入"
                        v-model="device.sn">
                    </el-input>
                </el-form-item>
                <el-form-item label="绑定患者" label-width="100px">
                    <el-input
                        type="text"
                        placeholder="请输入绑定患者手机号"
                        maxlength="11"
                        v-model="device.phone">
                    </el-input>
                </el-form-item>
                <el-form-item label="固件版本" label-width="100px">
                    <el-input
                        type="text"
                        placeholder="请输入"
                        v-model="device.version">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" @click="addVisible = false" size="mini">取消</el-button>
                   <el-button type="primary" @click="addDevice()" size="mini">提交</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="导入数据"
            :visible.sync="importTag"
            width="600px"
            :fullscreen="false"
            :before-close="cancelFc"
        >
            <div>
                <input type="file" ref="fileInput" @change="importExcel"/>
                <el-table
                    :data="excelData"
                    style="width: 100%"
                    border
                    stripe
                    lazy
                >
                    <el-table-column
                        prop="watchType"
                        label="设备型号"
                    ></el-table-column>
                    <el-table-column
                        prop="bleMac"
                        label="MAC"
                    ></el-table-column>
                    <el-table-column
                        prop="sn"
                        label="SN"
                    ></el-table-column>
                    <el-table-column
                        prop="phone"
                        label="绑定患者"
                    ></el-table-column>
                    <el-table-column
                        prop="version"
                        label="固件版本"
                    ></el-table-column>
                </el-table>
                <div>共 {{ excelData.length }} 条数据</div>
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="info" @click="cancelFc" size="mini">取消</el-button>
                 <el-button type="primary" @click="importFc()" size="mini">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import * as XLSX from 'xlsx';

export default {
    name: 'index',
    data() {
        return {
            loginName:localStorage.getItem("phone"),
            ratio: 1,
            time: '',
            mac: '',
            sn: '',
            watchType: '',
            deviceType: '',
            userName: '',
            bindTime: '',
            isBind: '',
            watchModel: [],
            tableData: [],
            total: 0,
            pageNum: 1,
            pageSize: 20,
            tableSelection: '',
            addVisible: false,
            device: {
                watchType: '',
                bleMac: '',
                sn: '',
                phone: '',
                version: ''
            },
            importTag: false,
            excelData: []
        }
    },
    mounted() {
        this.ratio = document.documentElement.clientWidth / 1920;
        this.startTimer();
        this.getWatchModelList();
        this.search()
    },
    methods: {
        toHome() {
            this.$router.push({
                path: '/home',
            })
        },
        toUser() {
            this.$router.push({
                name: 'user'
            })
        },
        toData() {
            this.$router.push({
                name: 'data'
            })
        },
        toAdmin() {
            this.$router.push({ path: '/admin' });
        },
        getTime() {
            let time = new Date();
            let year = time.getFullYear();
            let month = (time.getMonth() + 1).toString().padStart(2, '0');
            let day = time.getDate().toString().padStart(2, '0');
            let hour = time.getHours().toString().padStart(2, '0');
            let minute = time.getMinutes().toString().padStart(2, '0');
            let second = time.getSeconds().toString().padStart(2, '0');
            this.time = year + '/' + month + '/' + day + '\n' + hour + ':' + minute + ':' + second;
            this.latestTime = this.time
        },
        startTimer() {
            // 立即执行一次
            this.getTime();
            // 每秒执行一次
            setInterval(() => {
                this.getTime();
            }, 1000);
        },
        getWatchModelList() {
            this.$api.device.getWatchModelList({
                pageNum: 1,
                pageSize: 200
            }).then(res => {
                let data = res.data.items
                this.watchModel = [];
                for (let i = 0; i < data.length; i++) {
                    let modelList = data[i].model.split(',');
                    let type = {
                        value: data[i].type,
                        label: data[i].type,
                        children: []
                    };
                    for (let j = 0; j < modelList.length; j++) {
                        let model = {
                            value: modelList[j],
                            label: modelList[j]
                        };
                        type.children.push(model)
                    }
                    this.watchModel.push(type);
                }
            })
        },
        tableSelectionChange(val) {
            this.tableSelection = val;
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.search();
        },
        handleCurrentChange(val) {
            this.pageNum = val;
            this.search();
        },
        search() {
            this.$api.device.getDeviceList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                mac: this.mac,
                sn: this.sn,
                watchType: this.watchType,
                userName: this.userName,
                startDate: this.bindTime[0],
                endDate: this.bindTime[1],
                isBind: this.isBind
            }).then(response => {
                this.tableData = response.data.items;
                this.total = response.data.count;
                if (this.total != 0 && this.tableData.length == 0) {
                    this.pageNum = 1;
                    this.search()
                }
            })
        },
        reset() {
            this.mac = '';
            this.sn = '';
            this.watchType = '';
            this.userName = '';
            this.bindTime = '';
            this.isBind = '';
            this.search();
        },
        addDevice() {
            if (this.device.id) {
                this.$api.device.updateDevice({
                    id: this.device.id,
                    watchType: this.device.watchType,
                    bleMac: this.device.bleMac,
                    sn: this.device.sn,
                    phone: this.device.phone,
                    watchVersion: this.device.version
                }).then(res => {
                    this.$message.success('修改成功');
                    this.addVisible = false;
                    this.search();
                    this.device = {
                        watchType: '',
                        bleMac: '',
                        sn: '',
                        phone: '',
                        version: ''
                    }
                })
            } else {
                this.$api.device.addDevice({
                    watchType: this.device.watchType,
                    bleMac: this.device.bleMac,
                    sn: this.device.sn,
                    phone: this.device.phone,
                    watchVersion: this.device.version
                }).then(res => {
                    this.$message.success('添加成功');
                    this.device = {
                        watchType: '',
                        bleMac: '',
                        sn: '',
                        phone: '',
                        version: ''
                    }
                    this.addVisible = false;
                    this.search();
                })
            }
        },
        importExcel(event) {
            let files = event.target.files;
            let fileReader = new FileReader();
            fileReader.onload = (ev) => {
                try {
                    var data = ev.target.result,
                        workbook = XLSX.read(data, {
                            type: 'binary'
                        }), // 以二进制流方式读取得到整份excel表格对象
                        excelData = []; // 存储获取到的数据
                } catch (e) {
                    console.log('文件类型不正确');
                    return;
                }

                // 表格的表格范围，可用于判断表头是否数量是否正确
                var fromTo = '';
                // 遍历每张表读取
                for (var sheet in workbook.Sheets) {
                    if (workbook.Sheets.hasOwnProperty(sheet)) {
                        fromTo = workbook.Sheets[sheet]['!ref'];
                        excelData = excelData.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
                        // break; // 如果只取第一张表，就取消注释这行
                    }
                }
                this.dealExcelData(excelData)
            };
            fileReader.readAsBinaryString(files[0]);
        },
        dealExcelData(arr) {
            this.excelData = [];
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].设备型号) {
                    this.excelData.push({
                        watchType: arr[i].设备型号,
                        bleMac: arr[i].MAC,
                        sn: arr[i].SN,
                        phone: arr[i].绑定患者手机号,
                        version: arr[i].固件版本
                    })
                }
            }
        },
        cancelFc() {
            this.importTag = false;
            this.excelData = [];
            const fileInput = this.$refs.fileInput;
            if (fileInput) {
                fileInput.value = ''; // 清空文件输入框
            }
        },
        importFc() {
            this.$api.device.importDevice(this.excelData).then(res => {
                if (res.result == 1) {
                    this.$message({
                        message: '导入成功',
                        type: 'success'
                    });
                    this.search()
                    this.cancelFc()
                }
            })
        },
        openDeleteDevice(tag, item) {
            this.$confirm('确定要删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let deleteData = [];
                if (tag === 0) {
                    deleteData = [item]
                } else {
                    deleteData = this.tableSelection
                }
                this.deleteDevice(deleteData)
            })
        },
        deleteDevice(deleteData) {
            this.$api.device.deleteDevice(deleteData).then(res => {
                if (res.result == 1) {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.search()
                }
            })
        },
        openEditDevice(device) {
            this.device = device
            this.addVisible = true
        },
        deleteWatchBind(item) {
            this.$confirm('确定要解绑?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.device.deleteWatchBind(item).then(res => {
                    if (res.result == 1) {
                        this.$message({
                            message: '解绑成功',
                            type: 'success'
                        });
                        this.search()
                    }
                })
            })
        }
    }
}
</script>

<style scoped>
.content {
    width: 1920px;
    height: 1080px;
    background-color: #0A192F;
    background-image: url("~@/assets/home/01bg.png");
    background-size: cover;
    box-sizing: border-box;
    overflow-x: hidden;
    font-size: 14px;
}

.main {
    width: 1728px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 0px 0px 0px 0px;
    margin: 0 auto;
    padding: 38px 53px 20px 32px;
    font-size: 14px;
}

/deep/ .el-input__inner {
    background-color: rgba(0, 111, 255, 0.1);
    color: #ffffff;
    border: 1px solid rgba(0, 136, 255, 0.6);
}

/deep/ .el-cascader__dropdown {
    background: rgba(0, 111, 255, 0.1);
}

/deep/ .el-range-input {
    background-color: rgba(0, 111, 255, 0.1);
    color: #ffffff;
}

/deep/ i {
    font-size: 12px;
}

.btn-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;
}

.table-btn {
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
}

.table-btn0 {
    color: #0088FF;
}

.table-btn1 {
    color: #1CB9FF;
}

.table-btn2 {
    color: #FF3A62;
}

/deep/ .el-table {
    height: 600px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/device/index.vue